import type { StaticFieldValue } from "./static-field.type";

export const STATIC_FIELD_VALUES = Array.from(
  { length: 5 },
  (_, i) => (i + 1) as StaticFieldValue
);
